import React, { useEffect, useState } from 'react';
import { Link, Route, Switch } from 'react-router-dom';
import { Avatar, Card, Col, Divider, Layout, Row } from 'antd';
import UIStore from '../../stores/UIStore';
import UserStore from '../../stores/UserStore';
import FourOhFour from '../../pages/404';
import { observer } from 'mobx-react';
import { configure } from 'mobx';
import { PasswordSetup } from '../../pages';
import PortalAuth from '../../pages/PortalAuth';
import Support from '../../pages/Support';
import { RapidQuoteSuccess } from '../../pages/RapidQuote';
import { PurchaseOrderSubmission } from '../../pages/PurchaseOrderSubmittion';
import PortalHeader from 'layouts/sections/PortalHeader';
import StartRapidQuote from 'pages/RapidQuote/StartQuote';
import Footer from 'components/Footer';
import { WelcomeToGetQuote } from '../../pages/GetQuote';

import OrderReview from '@/pages/OrderReview';
import PortalLogin from '@/pages/PortalLogin';
import PortalRegister from '@/pages/PortalRegister';
import PortalResetPassword from "@/pages/PortalPasswordReset";
import RedirectPreservingUTMQuery from '../../common/RedirectPreservingUTMQuery';

configure({ enforceActions: 'observed' });

const { Content } = Layout;

interface Props {
    children: Element;
}

const PublicRouter = (props: Props) => {
    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

    useEffect(() => {
        if (selectedKeys !== UIStore.selectedKey) {
            setSelectedKeys(UIStore.selectedKey);
        }
    }, [UIStore.selectedKey]);

    return (
        <>
            <div
                className={'header-container'}
                style={{
                    flex: '0 0 auto',
                }}
            >
                <PortalHeader />
            </div>
            <div
                className="main-container"
                style={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    minHeight: 0,
                }}
            >
                {props.children}
                <Switch>
                    <Route exact path="/old">
                        <div style={{ textAlign: 'center' }}>
                            <Avatar
                                style={{
                                    verticalAlign: 'middle',
                                    backgroundColor: '#cc0000',
                                    color: '#fff',
                                    fontWeight: 'bold',
                                    fontSize: '32px',
                                }}
                                size={64}
                            >
                                {UserStore.first_initial || 'PB'}
                            </Avatar>
                            <Divider className="spacing" />
                            <h3>Welcome, {UserStore?.user?.default_contact?.fullname}</h3>
                            <p>PartsBadger works for you. Here's a quick glance how we can help.</p>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Card className="hoverable">
                                        <Link to={'quote'}> Quote</Link>
                                    </Card>
                                </Col>
                                <Col span={12}>
                                    <Card className="hoverable">
                                        <Link to={'my-account'}> Account</Link>
                                    </Card>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Card className="hoverable">
                                        <Link to={'order-requirements'}> Order Requirements</Link>
                                    </Card>
                                </Col>
                                <Col span={12}>
                                    <Card className="hoverable">
                                        <Link to={'support'}> Support</Link>
                                    </Card>
                                </Col>
                            </Row>
                        </div>
                    </Route>

                    <Route path="/order-form/:quote_number/" exact component={PurchaseOrderSubmission} />
                    {/* <CheckForQuoteToken> */}
                    <Route path="/rapid-quote" exact component={WelcomeToGetQuote} />
                    <Route path="/rapid-quote/start" exact component={WelcomeToGetQuote} />
                    <Route path="/rapid-quote/start-v1" exact component={StartRapidQuote} />
                    <Route
                        path="/rapid-quote/checkout/:orderId/"
                        render={routeProps => <OrderReview {...routeProps} mode="rapid" />}
                    />

                    {/* </CheckForQuoteToken> */}
                    <Route path="/rapid-quote/success" exact component={RapidQuoteSuccess} />
                    <Route path="/support" exact component={Support} />
                    <Route path="/password-setup" exact component={PasswordSetup} />
                    <Route path="/maker" exact render={() => <RedirectPreservingUTMQuery to="/" />} />
                    <Route path="/" exact>
                        <PortalAuth />
                    </Route>

                    <Route path="/login" exact>
                        <PortalLogin />
                    </Route>

                    <Route path="/register" exact>
                        <PortalRegister />
                    </Route>

                    <Route path="/reset-password/" exact>
                        <PortalResetPassword />
                    </Route>

                    {!props.children && <Route component={FourOhFour} />}
                </Switch>
            </div>
            <div
                className={'footer-container'}
                style={{
                    flex: '0 0 auto',
                }}
            >
                <Footer />
            </div>
        </>
    );
};

export default observer(PublicRouter);
